module.exports = __webpack_public_path__ + "nebular.bfbfd2c47a08b07c3a4f.woff";


//////////////////
// WEBPACK FOOTER
// /srv/dev/FitRadioAdmin2/src/app/@nebular/icons/fonts/nebular.woff?jaecku
// module id = ../../../../../src/app/@nebular/icons/fonts/nebular.woff?jaecku
// module chunks = styles